export enum SALES_PROCESS_TOOL_ACTIONS {
    LOAD_BRANDED_NOTES = '[Sales Process Tool] Load Branded Notes',
    RESET_STATE = '[Sales Process Tool] Reset Note State',
    TOGGLE_NOTE_READ = '[Sales Process Tool] Toggle Note Read',
}

export namespace SalesProcessToolAction {
    export class ResetState {
        static readonly type = SALES_PROCESS_TOOL_ACTIONS.RESET_STATE
    }

    export class LoadBrandedNotes {
        static readonly type = SALES_PROCESS_TOOL_ACTIONS.LOAD_BRANDED_NOTES
        constructor(public payload: string) {}
    }

    export class ToggleNoteRead {
        static readonly type = SALES_PROCESS_TOOL_ACTIONS.TOGGLE_NOTE_READ
        constructor(public payload: number) {}
    }
}